import styled from "styled-components";
import { StyledEngineProvider } from "@mui/material/styles";

import NewExtractionForm from "../components/NewExtractionForm";

import closeIcon from "../images/closeIcon.svg";
import { Warning } from "@mui/icons-material";

function ModalExtractitionForm(props) {
  if (props.modalExtractionFormState) {
    return (
      <Container>
        <Img
          src={closeIcon}
          onClick={() => props.setModalExtractionFormState(false)}
        ></Img>
        <SubContainer>
          <ContentContainer>
            <Title>Nova extração</Title>
            <CardInfo>
              <p>
                Antes de você adicionar as suas extrações tem três informações
                IMPORTANTES que você precisa saber:
              </p>
              <p>1° As extrações demoram 1 dia para cair;</p>
              <p>
                2° As extrações inseridas serão validadas, se validadas
                corretamente então serão incluídas no banco de dados;
              </p>
              <p>
                3° LEIA os guias de usuários dos respectivos extratores antes de
                fazer uma extração.
              </p>
            </CardInfo>

            <WarningSection>
              <WarningTitle>
                <Warning />

                <span>
                  Alguns extratores não estão mais disponíveis aqui! Para
                  criá-los, acesse a plataforma{" "}
                  <a
                    href={"https://voldemort.raccoon.ag/pt/metrics"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    metrics.monks
                  </a>
                  .
                </span>
              </WarningTitle>
            </WarningSection>

            <StyledEngineProvider injectFirst>
              <NewExtractionForm
                clients={props.clients}
                setNewError={props.setNewError}
                setModalController={props.setModalController}
              ></NewExtractionForm>
            </StyledEngineProvider>
          </ContentContainer>
        </SubContainer>
      </Container>
    );
  }
}

export default ModalExtractitionForm;

const Container = styled.div`
  width: 35vw;
  max-width: 455px;
  height: 90vh;

  background-color: #333333;

  margin: auto 2vw auto 0;

  border-radius: 20px;

  position: relative;

  @media (max-width: 1300px) {
    max-width: 300px;
  }
`;

const Img = styled.img`
  width: 30px;
  height: 30px;

  position: absolute;
  right: 15px;
  top: 15px;

  cursor: pointer;
`;

const SubContainer = styled.div`
  margin: 15px;
  margin-top: 60px;
  height: 90%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: #333333;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #242424;
    border-radius: 12px;
  }

  @media (max-width: 1300px) {
    height: 85%;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: justify;
  margin: 10px;
`;

const Title = styled.h1`
  margin-top: 0;

  font-family: "HelveticaNowforMonksExtraBold", sans-serif;
  font-size: 2.5em;

  color: #f6be27;

  @media (max-width: 1500px) {
    font-size: 1.7rem;
  }
`;

const CardInfo = styled.div`
  color: #e2e2e2;
  font-size: 14.5px;
  font-family: "Open Sans", sans-serif;

  background-color: #242424;
  border-radius: 5px;
  padding: 10px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

const WarningSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  background-color: #f6be2780;
  border: 1px solid #f6be27;

  border-radius: 5px;

  padding: 10px;
`;

const WarningTitle = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  gap: 12px;

  svg {
    color: #f6be27;
  }

  span {
    margin: 0;
    font-size: 14px;
    color: #ffffff90;
  }

  a {
    color: #f6be27;
  }
`;
